import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [path, setPath] = useState(["Member", "member"]);
  const [crossProductList1, setCrossProductList1] = useState(null);
  const [crossProductList2, setCrossProductList2] = useState(null);

  const updatePath = (index, newValue) => {
    setPath((prevPath) => {
      // If value is null, remove from path
      if (newValue === null) {
        return prevPath.filter((item, i) => i < index);
      }
      // If index is within bounds, update the element at the specified index
      if (index >= 0 && index < prevPath.length) {
        return prevPath.map((item, i) => (i === index ? newValue : item));
      } else {
        // index is out of bounds, push the new value onto the array
        return [...prevPath, newValue];
      }
    });
  };

  return (
    <SidebarContext.Provider
      value={{
        crossProductList1,
        setCrossProductList1,
        crossProductList2,
        setCrossProductList2,
        updatePath,
        path,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.element,
};

export const useSidebarContext = () => {
  return useContext(SidebarContext);
};
